export const indexesForValue = (startAt?: string, endAt?: string): [number, number] => {
  const [startHour, startMinute] = startAt?.split(':') || []
  const startIndex =
    (parseInt(startHour || '0', 10) || 0) * 2 + Math.floor((parseInt(startMinute || '0', 10) || 0) / 30)
  const [endHour, endMinute] = endAt?.split(':') || []
  const endIndex = (parseInt(endHour || '24', 10) || 24) * 2 + Math.floor((parseInt(endMinute || '0', 10) || 0) / 30)
  return [startIndex, endIndex]
}
